export default "__VITE_ASSET__vQxVn3JB__"